import React, { FC, ReactNode } from 'react';

import { classNames } from '../../utils/style';
import { textTitle1, textTitle3 } from '../../styles/typography';
import { applyBgColor } from '../../utils/utils';

export interface NavigationButtonsSectionProps {
  title?: string;
  subtitle?: string;
  navigationButtons?: ReactNode;
  backgroundColor?: string;
}

export const NavigationButtonsSection: FC<NavigationButtonsSectionProps> = ({
  title,
  subtitle,
  navigationButtons,
  backgroundColor,
}: any) => {
  return (
    <div
      className={`NavigationButtonsSection ${applyBgColor(backgroundColor)}`}
    >
      <div className="container">
        {(title || subtitle) && (
          <div className="flex flex-col items-center">
            {title && (
              <h2
                className={classNames(
                  'mb-24 text-center lg:w-5/8 xl:w-6/12 text-neutral-301',
                  textTitle1,
                )}
              >
                {title}
              </h2>
            )}
            {subtitle && (
              <p
                className={classNames(
                  'mb-56 text-center lg:w-5/8 xl:w-6/12 text-neutral-101',
                  textTitle3,
                )}
              >
                {subtitle}
              </p>
            )}
          </div>
        )}
        {navigationButtons && (
          <div className="flex flex-wrap justify-center -mx-12">
            {navigationButtons}
          </div>
        )}
      </div>
    </div>
  );
};
